
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import PensionUnitSelectionEdit from '@/components/PensionUnitSelection/PensionUnitSelectionEdit.vue';

@Component({
  components: {
    PensionUnitSelectionEdit,
  },
})
export default class PensionUnitSelectionEditButton extends Vue {
  @Prop(String) private id!: string;
  private showDialog = false;

  @Emit()
  private pensionUnitSelectionUpdated() {
    this.showDialog = false;
  }
}
